import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'react-clipboard.js';
import { MdCheck } from 'react-icons/md';

const clipboardStyles = {
	width: '100%',
	background: 'transparent',
	padding: '0',
};

const ClipboardButton = ({
	text,
	toCopy,
	successText,
	onSuccess,
	customComponent,
	customStyles,
	renderBody,
	children,
}) => {
	const [buttonText, setButtonText] = useState(text || 'Copy and share link');

	const reset = () => {
		setButtonText(text);
	};

	return (
		<Clipboard
			style={{ ...clipboardStyles, ...customStyles }}
			component={customComponent}
			data-clipboard-text={toCopy}
			onSuccess={() => {
				setButtonText(successText);
				onSuccess();
			}}
		>
			{renderBody ? renderBody({ buttonText }, reset) : children}
		</Clipboard>
	);
};

ClipboardButton.propTypes = {
	text: PropTypes.node,
	toCopy: PropTypes.string,
	successText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onSuccess: PropTypes.func,
	customComponent: PropTypes.node,
	children: PropTypes.node,
	customStyles: PropTypes.object,
	renderBody: PropTypes.func,
};

ClipboardButton.defaultProps = {
	successText: (
		<span>
			Link copied <MdCheck />
		</span>
	),
	onSuccess: () => {},
	reset: () => {},
};

export default ClipboardButton;
